class DateRangeSelectorModalController {
    constructor($uibModalInstance) {
        this.modalInstance = $uibModalInstance;
        this.data = {
            start_date: new Date(),
            end_date: new Date()
        }
    }

    close() {
        this.modalInstance.close(this.data);
    }

    dismiss() {
        this.modalInstance.dismiss();
    }
}

DateRangeSelectorModalController.$inject = [
    '$uibModalInstance'
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:InvoicesCancelModalCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.components')
    .controller('DateRangeSelectorModalController', DateRangeSelectorModalController);



// WEBPACK FOOTER //
// ./src/app/components/services/resourcecommon/controllers/date-range-selector-modal-controller.js